<template>
  <div class="table-responsive" style="height: 85vh">
    <report-sidenav></report-sidenav>
    <router-view id="page-content-wrapper"></router-view>
  </div>
</template>

<script>
import ReportSideNav from '@/components/sub_components/reports/ReportSideNav';

export default {
  name: 'ReportsIndex',
  components: {
    'report-sidenav' : ReportSideNav
  }
};
</script>

<style scoped>

</style>
